import React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {KeyValueCell, KeyValueColumn, KeyValueTable} from '@igp/shared/components/key-value-table';
import {ReferrerType} from '@igp/shared/contract/pam';
import {useReferralInfoData, UserReferralInfoForm} from '@igp/shared/features/player-referral';
import {useUserProfileDetails} from '@igp/shared/features/user-profile';
import {EntityType} from '@models';

const localized = defineMessages({
    title: {
        id: 'PlayerReferral_title',
        defaultMessage: 'Referrer Info',
    },
    referrerTypeAndTrackingId: {
        id: 'ReferrerInfo_referrerTypeAndTrackingId',
        defaultMessage: 'Referrer Type and Tracking ID',
    },
});

type PlayerReferralProps = {
    uid: string;
};

export function PlayerReferral({uid}: PlayerReferralProps) {
    const {formatMessage} = useIntl();
    const {referral, affiliate} = useReferralInfoData<EntityType>(
        'UserReferralKeyValueTable',
        localized.title,
        uid,
        EntityType.PlayerReferral,
        EntityType.UserProfile
    );

    const viewType = 'UserReferralInfo';
    const {item: user} = useUserProfileDetails({
        id: referral?.referrer_id,
        viewType,
        fields: ['uid', 'agent_info.is_agent', 'aal'],
    });

    const isAgentReferrer = user?.agent_info?.is_agent;
    return (
        <KeyValueTable mode="card">
            <KeyValueColumn>
                <KeyValueCell title={formatMessage(localized.referrerTypeAndTrackingId)}>
                    <UserReferralInfoForm
                        userId={uid}
                        referral={referral}
                        affiliate={affiliate}
                        isAgentReferrer={isAgentReferrer}
                        aal_groups={user?.aal}
                        availableTypes={[ReferrerType.P2P]}
                        referralInfoEditMode={'editable'}
                        disabled
                    />
                </KeyValueCell>
            </KeyValueColumn>
        </KeyValueTable>
    );
}
